export const NUMERIC_MAX_VALUE = 9007199254740990;
export const NUMERIC_MIN_VALUE = -2147483648;
export const NUMERIC_MAX_SCALE = 10;

export const VAR_PREFIX = 'VAR_DOCECM_';
